import { render, staticRenderFns } from "./FontFamilyDropdown.vue?vue&type=template&id=63c4f28f&scoped=true"
import script from "./FontFamilyDropdown.vue?vue&type=script&lang=js"
export * from "./FontFamilyDropdown.vue?vue&type=script&lang=js"
import style0 from "./FontFamilyDropdown.vue?vue&type=style&index=0&id=63c4f28f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c4f28f",
  null
  
)

export default component.exports